import moment from "moment/moment";

const state = {
    list: []

};

const mutations = {
    setMenuList(state, payload) {
        Object.keys(payload).forEach((key) => {
            if (payload[key]) {
                state.list[key] = payload[key];
            }
        });
        localStorage.setItem(
            "menuList",
            JSON.stringify({
                version: moment(Date.now()).format("YYYY-MM-DD"),
                data: {
                    ...state.list,
                },
            })
        );
    },
    clearMenuList(state, payload) {
        state = {
            list: [],
        };
        localStorage.setItem(
            "menuList",
            JSON.stringify({
                version: moment(Date.now()).format("YYYY-MM-DD"),
                data: {
                    ...state.list,
                },
            })
        );
    },
};

export default {
    namespaced: true, // 开启namespace:true，该模块就成为命名空间模块了
    state,
    mutations,
};
